import React, { useEffect, useRef, useState } from 'react';
import { HG } from './HG';
import { PlayerHeader, PlayerMain, PlayerWrapper } from './PlayerWrapper';
import { Text } from '@libs/uikit/Components';

const google = window.google;

export const GooglePlayer = ({ data, onEvent, count }) => {
    const adContainer = useRef(null);
    const videoContent = useRef(null);
    const [adsLoader, setAdsLoader] = useState(null);
    const [adsManager, setAdsManager] = useState(null);
    const [event, setEvent] = useState(null);

    useEffect(() => {
        const adDisplayContainer = new google.ima.AdDisplayContainer(
            adContainer.current,
            videoContent.current,
        );
        adDisplayContainer.initialize();
        setAdsLoader(new google.ima.AdsLoader(adDisplayContainer));
    }, [adContainer, videoContent, setAdsLoader, count]);

    useEffect(() => {
        if (adsLoader) {
            const _onAdsManagerLoaded = adsManagerLoadedEvent => {
                setAdsManager(
                    adsManagerLoadedEvent.getAdsManager(videoContent),
                );
            };

            google.ima.settings.setVpaidMode(
                google.ima.ImaSdkSettings.VpaidMode.ENABLED,
            );
            adsLoader.addEventListener(
                google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
                _onAdsManagerLoaded,
                false,
            );
            const adsRequest = new google.ima.AdsRequest();
            if (data.value.startsWith("<")) {
                adsRequest.adsResponse = data.value;
                adsRequest.adTagUrl = '';
            } else {
                adsRequest.adsResponse = '';
                adsRequest.adTagUrl = data.value;
            }

            adsLoader.requestAds(adsRequest);
        }
    }, [adsLoader, data, setAdsManager, videoContent, count]);

    useEffect(() => {
        if (adsManager) {
            Object.values(google.ima.AdEvent.Type)
                .forEach(event => adsManager.addEventListener(event, setEvent));
            adsManager.init(0, 0, google.ima.ViewMode.NORMAL);
            adsManager.start();
        }

        return () => {
            adsManager && adsManager.destroy();
        };
    }, [adsManager, count]);

    useEffect(() => {
        event && onEvent({type: event.type});
    }, [event, count]);

    return (
        <PlayerWrapper className="player-wrapper__google">
            <PlayerHeader>
                preview
                <img src="./assets/google.png" alt="" />
            </PlayerHeader>
            <PlayerMain>
                <div className="ad-wrapper">
                    <div className="video-content">
                        <video
                            muted
                            className="content-element"
                            controls
                            ref={videoContent}
                        >
                            <source src="./assets/loopme.mp4"></source>
                        </video>
                    </div>
                    <div className="ad-container" ref={adContainer}></div>
                </div>
            </PlayerMain>
            <HG style={{ margin: '16px 0' }}>
                <Text style={{ flex: 1 }} info>
                    &nbsp;
                </Text>
                <Text caption>&nbsp;</Text>
            </HG>
        </PlayerWrapper>
    );
};
